import { useState } from "react";
import Table from "react-bootstrap/Table";
import { FiChevronDown, FiChevronLeft } from "react-icons/fi";

export default function ReportTable({ data, isMobile }) {
    const [expandedRowId, setExpandedRowId] = useState(null);
    const toggleRow = (id) => setExpandedRowId(id === expandedRowId ? null : id);

    const renderExpandButtonCell = (rowId) => {
        if (!isMobile) return null;

        const isExpanded = expandedRowId === rowId;

        return (
            <td>
                <button
                    onClick={() => toggleRow(rowId)}
                    style={{
                        background: "none",
                        border: "none",
                        fontSize: "24px",
                        cursor: "pointer",
                        padding: 0
                    }}
                >
                    {isExpanded ? <FiChevronDown /> : <FiChevronLeft />}
                </button>
            </td>
        );
    };

    const renderVisibleColumns = (row) => {
        return visibleColumns.map((column) => (
            <td key={column.field} style={getColumnStyle(column.type)}>
                {renderCell(column, row[column.field], row.id, row.type)}
            </td>
        ));
    };
    const renderExpandableDataView = (row) => {
        return isMobile && expandedRowId === row.id && (
            <tr key={`expanded-${row.id}`}>
                <td colSpan={visibleColumns.length + 1}>
                    <div style={{ background: "#f9f9f9", padding: "10px" }}>
                        {data.columns
                            .filter(c => !c.visibleOnMobile)
                            .map(column => (
                                <div key={column.field}>
                                    <strong>{column.description}:</strong>{" "}
                                    {renderCell(column, row[column.field], row.id, row.type)}
                                </div>
                            ))}
                    </div>
                </td>
            </tr>
        )
    };

    const visibleColumns = isMobile ? data.columns.filter(c => c.visibleOnMobile) : data.columns;

    return (
        <div style={{ background: "white", margin: "auto", direction: "rtl", padding: "10px" }}>
            <Table responsive>
                <thead>
                    <tr>
                        {isMobile && <th></th>}
                        {visibleColumns.map((column) => (
                            <th key={column.field}>{column.description}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.rows.map((row) => (
                        <>
                            <tr key={row.id}>
                                {renderExpandButtonCell(row.id)}
                                {renderVisibleColumns(row)}
                            </tr>
                            {renderExpandableDataView(row)}
                        </>
                    ))}
                </tbody>
            </Table>
        </div>
    );
}

const getColumnStyle = (type) => {
    if (type === "number") return { direction: "ltr", textAlign: "right" };
    if (type === "longText") return { maxWidth: "100px" };
    if (type === "button" || type === "iconButton") return { width: "10px" };
    if (type === "time") return { minWidth: "100px" };
    return {};
};

const renderCell = (column, value, id, type) => {
    if (column?.type === "button") {
        return (
            <img
                width={20}
                src={column.icon}
                onClick={() => column.onClick(id, type)}
                style={{ cursor: "pointer" }}
            />
        );
    }
    if (column?.type === "iconButton") {
        const IconComponent = column.icon;
        return (
            <IconComponent
                size={20}
                onClick={() => column.onClick(id, type)}
                style={{ cursor: "pointer" }}
            />
        );
    }
    return value;
};
